import Head from 'expo-router/head';

type DocumentTitleProps = {
  title: string;
};

export function DocumentTitle({ title }: DocumentTitleProps) {
  const trimmed = title.trim() || 'Untitled';
  return (
    <Head>
      <title>{`${trimmed} · Couplespace`}</title>
    </Head>
  );
}
